import { put, call, select, take, race, takeLatest } from 'redux-saga/effects';
import {
    GET_DEALERS_REQUEST,
    getDealersRequest,
    getDealersSuccess,
    getDealersFailure,
    SUBMIT_DEALER_REQUEST,
    submitDealerSuccess,
    submitDealerFailure,
    DELETE_DEALER_REQUEST,
    deleteDealerSuccess,
    deleteDealerFailure
} from '../actions/dealers';
import { getDealers, postDealers, putDealers, deleteDealers } from '../services/dealers';
import { showGlobalError } from '../../app/actions/app';
import { accessTokenSelector } from '../../auth/selectors/token';
import { getCompaniesWorker } from '../../companies/sagas/companies';
import { getCompaniesAccesor } from '../../companies/selectors/companies';
import { GET_COMPANIES_SUCCESS, GET_COMPANIES_FAILURE } from '../../companies/actions/companies';


export const getDealersWorker = function* (payload) {
    try {
        yield put(getDealersRequest());
        yield call(getDealersAllWorker, payload);

    } catch (err) {
        yield put(getDealersFailure(err));
        yield put(showGlobalError(true, err));
    }
};

const getDealersAllWorker = function* ({ payload: { filters = {} } = {} } = {}) {
    try {

        const token = yield select(accessTokenSelector);

        const {
            data: { dealers, total }
        } = yield call(getDealers, filters, token);

        let { companies, fetching: companiesFetching } = yield select(getCompaniesAccesor);

        if (companiesFetching) {
            // NOTE: a companies fetch is already in-flight (eg. triggered by the company filter select),
            // wait for it instead of firing a duplicate GET /companies (the http cache placeholder can't
            // tell two concurrent identical requests apart and would resolve the second one empty).
            yield race({
                success: take(GET_COMPANIES_SUCCESS),
                failure: take(GET_COMPANIES_FAILURE)
            });
            ({ companies } = yield select(getCompaniesAccesor));
        } else if (!companies.length) {
            yield call(getCompaniesWorker);
            ({ companies } = yield select(getCompaniesAccesor));
        }

        yield put(getDealersSuccess(dealers, total, companies));

    } catch (err) {
        yield put(getDealersFailure(err));
        yield put(showGlobalError(true, err));
    }
};

const submitDealerWorker = function* ({ payload: { dealer } }) {
    try {
        const token = yield select(accessTokenSelector);

        if (!dealer.identifier) {
            yield call(postDealers, dealer, token);
            yield put(showGlobalError(true, 200, 'created'));
        } else {
            yield call(putDealers, dealer, token);
            yield put(showGlobalError(true, 200, 'updated'));
        }

        yield put(submitDealerSuccess(dealer));
    } catch (err) {
        yield put(showGlobalError(true, err));
        yield put(submitDealerFailure(err));
    }
};

const deleteDealerWorker = function* ({ payload: { dealer } }) {
    try {
        const token = yield select(accessTokenSelector);

        yield call(deleteDealers, dealer, token);

        yield put(deleteDealerSuccess(dealer));
    } catch (err) {
        yield put(showGlobalError(true, err));
        yield put(deleteDealerFailure(err));
    }
};

export default [
    takeLatest(GET_DEALERS_REQUEST, getDealersAllWorker),
    takeLatest(SUBMIT_DEALER_REQUEST, submitDealerWorker),
    takeLatest(DELETE_DEALER_REQUEST, deleteDealerWorker),
    getDealersWorker
];
